// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: false,

  lng: "bg",
  medialng: "bg",



    // wsUrl: "wss://wb-dev.daskal.eu/svilen-ws/r",
  //wsUrl: "ws://localhost:8084/r",
    wsUrl: "wss://content.daskal.eu/wb/r",
    // urlPlayer: 'https://wb-dev.daskal.eu/svilen-wb-client/#/player/' ,

  imageUrl: "https://content.daskal.eu/daskal/",

  //   wbBackendUrl: "https://wb-dev.daskal.eu/wb/",
  //wbBackendUrl: "http://localhost:8084/",
  wbBackendUrl: "https://content.daskal.eu/wb/",

  contentsBackendUrl: "https://content.daskal.eu/cnt/",
  // contentsBackendUrl:"https://content.daskal.eu/",
  contentsFileMapping: "resources/",
  contentsBackendMediaUrl: "https://video.daskal.eu/",
  wbStateSize: 1000000,
  contentModule: true,
  changeInterval: 10000,
  mediawbposter: "a/videojs/audio-poster.png",
    // urlPlayer: 'https://content.daskal.eu/client/#/player/' ,
 urlPlayer: 'https://content.daskal.eu/client/#/player/',
 //urlPlayer: 'http://127.0.0.1:4203/#/player/',
  extId: "gcgjliaggalhdhafgnkoobdmmmdbgnlj",
  footerLogo: "assets/images/logo_daskal.png",
  closeRedirection: "https://daskal.eu",
  hbSendInterval: 4000,
  hbCheckInterval: 4000,
  hbCheckThreshold: 4,
  useHb: true, 
  logo: ""
};


// WEBPACK FOOTER //
// /app/src/environments/environment.pre.ts